import { Switch, SwitchProps } from '@mui/material'

export type C1SwitchProps = SwitchProps

export { Switch as C1Switch }
